// @noflow
import './styles.css';

import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Template } from '../';

const propTypes = {
    selectTemplate: PropTypes.func.isRequired,
    templatesList: ImmutablePropTypes.listOf(PropTypes.string)
};

const TemplatesList = ({ selectTemplate, templatesList }) => (
    <div className="templates-list">
        {templatesList.map((templateName, i) => (
            <Template key={`template-${i}`} name={templateName} selectTemplate={() => selectTemplate(templateName)} />
        ))}
    </div>
);

TemplatesList.propTypes = propTypes;

export default TemplatesList;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/templates-list/component.js